<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

var docEl = document.documentElement;

function setRemUnit() {
  console.log(docEl.clientWidth)
  var rem = docEl.clientWidth / 23.4375;
  docEl.style.fontSize = rem + 'px'
  console.log(rem)
}

setRemUnit()

window.addEventListener('resize', setRemUnit)
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    setRemUnit()
  }
})


export default {
  name: 'App'
}
</script>

<style>
#app {

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  /* background: rgb(6, 19, 69) !important; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue